var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReseticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7968_32977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14V16H2.5V14H4.5ZM5.5 0L6.93 1.41L4.35 4H10.13C13.13 4 15.5 6.69 15.5 10C15.5 13.31 13.13 16 10.13 16H5.5V14H10.11C11.99 14 13.5 12.21 13.5 10C13.5 7.79 11.99 6 10.13 6H4.35L6.93 8.59L5.5 10L0.5 5L5.5 0Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7968_32977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseticon);
export default __webpack_public_path__ + "static/media/reseticon.47ec57f5830595ab9f5cec9b945fd325.svg";
export { ForwardRef as ReactComponent };